<template>
  <div class="c-to-detail-page" @click="toPage">
    <div class="c-to-detail-page__content">
      <p class="title">{{ data.title }}</p>

      <div class="yellow-circle">
        <img src="@/assets/icon/icon_arrow_right.svg" />
      </div>
    </div>
  </div>
</template>
<script>
import { defineComponent } from 'vue';
import { useRouter } from 'vue-router';

export default defineComponent({
  name: '',
  props: {
    data: {
      type: Object,
      default: () => ({}),
    },
  },
  setup(props) {
    const router = useRouter();

    const toPage = () => {
      router.push(props.data.route);
    };

    return {
      toPage,
    };
  },
});
</script>
<style lang="scss" scoped>
.c-to-detail-page {
  background-color: $c-main-light-pink;
  border-radius: 20px;
  @include padding(24px 20px);
  cursor: pointer;

  &__content {
    @include flex(space-between);
    @include font-normal();
  }
}

.yellow-circle {
  flex: none;
  width: 40px;
  height: 40px;
  @include flex(center);
  background-color: $c-main-yellow;
  border-radius: 20px;
  margin-left: 10px;
}

@media screen and (min-width: $tablet) {
  .c-to-detail-page {
    @include padding(24px 44px);
  }
}
</style>
